import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {
  static targets = ["button"];

  expandAll(event) {
    event.preventDefault();
    document.dispatchEvent(createCustomEvent(this.expandEventName, this.element));
    this.isExpanded = true;
  }

  closeAll(event) {
    event.preventDefault();
    document.dispatchEvent(createCustomEvent(this.closeEventName, this.element));
    this.isExpanded = false;
  }

  iconFor(state) {
    return `<i class="fas fa-caret-${state === "expand" ? "down" : "up"}"></i>`;
  }

  //
  // GETTERS AND SETTERS
  //

  get expandEventName() {
    return `expand-all-${this.collectionName}`;
  }

  get closeEventName() {
    return `close-all-${this.collectionName}`;
  }

  get collectionName() {
    return this.data.get("collection-name");
  }

  get expandDataAction() {
    return `${this.identifier}#expandAll`;
  }

  get closeDataAction() {
    return `${this.identifier}#closeAll`;
  }

  get expandButtonText() {
    return `Expand All ${this.iconFor('expand')}`;
  }

  get closeButtonText() {
    return `Close All ${this.iconFor('close')}`;
  }

  set isExpanded(val) {
    const nextActionName = val ? "close" : "expand";
    this.buttonTarget.setAttribute("data-action", this[`${nextActionName}DataAction`]);
    this.buttonTarget.innerHTML = this[`${nextActionName}ButtonText`];
  }
};



// WEBPACK FOOTER //
// ./app/components/buttons/assets/javascript/buttons-expand-all-button-controller.js